import React from 'react';
import { useDropdown } from '../Dropdown';

export const List: React.FC = () => {
  const { dropdownItems } = useDropdown();

  return (
    <div
      className={`
        tw-relative
        overlay-gradient
        before:tw-pr-2
        before:tw-absolute
        before:tw-top-0
        before:tw-w-full
        before:tw-h-6
        before:tw-pointer-events-none
        after:tw-pr-2
        after:tw-absolute
        after:tw-bottom-0
        after:tw-w-full
        after:tw-h-6
        after:tw-pointer-events-none
      `}
    >
      <ul
        className={`
            tw-my-0
            tw-max-h-[268px]
            tw-overflow-auto
            tw-w-full
            tw-pl-0
            tw-overflow-x-hidden
            tw-rounded-2xl
          `}
      >
        {/* // TODO: replug filteredItemsBySearch instead of items when doing https://lafourche.atlassian.net/browse/LF-2071
         */}
        {dropdownItems.map(({ id, defaultChecked, onItemClick, children }) => {
          return (
            <li
              key={id}
              className={`
                  tw-border-0
                  tw-border-b
                  tw-border-solid
                  tw-border-blue-200
                  tw-h-14
                  tw-flex
                  tw-flex-row
                  tw-items-center
                  last:tw-border-b-0
                `}
            >
              <label
                htmlFor={id}
                className={`
                      tw-lf-body-regular-md
                      tw-flex
                      tw-items-center
                      tw-cursor-pointer
                      tw-w-full
                      tw-h-full
                    `}
              >
                <input
                  type="checkbox"
                  className={`
                        tw-lf-checkbox
                        tw-cursor-pointer
                        tw-ml-4
                        tw-mr-2
                      `}
                  id={id}
                  onChange={(event) => {
                    onItemClick(event);
                  }}
                  value={id}
                  checked={defaultChecked}
                  name={id}
                />
                <span className="tw-contents">{children}</span>
              </label>
            </li>
          );
        })}
      </ul>
      <style jsx>{`
        .overlay-gradient::before {
          content: '';
          background: linear-gradient(
            white,
            rgba(255, 255, 255, 0.001) 30%
          ); /* transparent keyword is broken in Safari */
        }
        .overlay-gradient::after {
          content: '';
          background: linear-gradient(
            rgba(255, 255, 255, 0.001) 30%,
            white
          ); /* transparent keyword is broken in Safari */
        }
      `}</style>
    </div>
  );
};
